import { type MutationError, trpc } from '@/shared/api';

interface UseSetProductInkColorsOptions {
  readonly onSuccess?: () => void;
  readonly onError?: () => void;
}

/** 상품의 허용 잉크 색상 저장 — useSetProductFonts 와 대칭. 지웠거나 없는 잉크가 섞이면 서버가 400 으로 거부한다. */
export const useSetProductInkColors = ({
  onSuccess,
  onError,
}: UseSetProductInkColorsOptions = {}) => {
  const mutation = trpc.productManagement.inkColors.setForProduct.useMutation({
    onSuccess,
    onError,
  });

  const error: MutationError | null = mutation.error;

  return {
    setProductInkColors: mutation.mutate,
    isPending: mutation.isPending,
    error,
  };
};
